import { render } from "./IDPProgressTimeline.vue?vue&type=template&id=5abbc35c&scoped=true"
import script from "./IDPProgressTimeline.vue?vue&type=script&lang=js"
export * from "./IDPProgressTimeline.vue?vue&type=script&lang=js"

import "./IDPProgressTimeline.vue?vue&type=style&index=0&id=5abbc35c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abbc35c"]])

export default __exports__